// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3zund","label":"styles_label__3xsjD"};